/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdmissionsBoardFacilityType = {
    HomeHealth: 'HOME_HEALTH',
    Hospice: 'HOSPICE',
} as const;
export type AdmissionsBoardFacilityType = typeof AdmissionsBoardFacilityType[keyof typeof AdmissionsBoardFacilityType];


export function instanceOfAdmissionsBoardFacilityType(value: any): boolean {
    for (const key in AdmissionsBoardFacilityType) {
        if (Object.prototype.hasOwnProperty.call(AdmissionsBoardFacilityType, key)) {
            if (AdmissionsBoardFacilityType[key as keyof typeof AdmissionsBoardFacilityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdmissionsBoardFacilityTypeFromJSON(json: any): AdmissionsBoardFacilityType {
    return AdmissionsBoardFacilityTypeFromJSONTyped(json, false);
}

export function AdmissionsBoardFacilityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionsBoardFacilityType {
    return json as AdmissionsBoardFacilityType;
}

export function AdmissionsBoardFacilityTypeToJSON(value?: AdmissionsBoardFacilityType | null): any {
    return value as any;
}

export function AdmissionsBoardFacilityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AdmissionsBoardFacilityType {
    return value as AdmissionsBoardFacilityType;
}

